import {
    FormControlLabel,
    MenuItem,
    Radio,
    RadioGroup,
    Select,
    TextField,
    InputLabel,
    InputAdornment,
    Stack,
    Typography,
    IconButton,
} from '@mui/material'

import { styled, useTheme } from '@mui/material/styles'

import Tooltip, { tooltipClasses } from '@mui/material/Tooltip'

// import Grid2 from '@mui/material/Unstable_Grid2' // Grid version 2
import HelpIcon from '@mui/icons-material/Help'

import UIElement from '../components/UIElement.js'

import LabelRow from '../components/LabelRow.js'
import React from 'react'
import appUtilities from '../utilities/appUtilities.js'
import { Colors } from '../styles/theme'
import useMediaQuery from '@mui/material/useMediaQuery'
// import { useTheme } from '@mui/material/styles'

const HtmlTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: '#f5f5f9',
        color: 'rgba(0, 0, 0, 0.87)',
        maxWidth: 320,
        fontSize: theme.typography.pxToRem(12),
        border: '2px solid #dadde9',
    },
}))

function getToolTip(helpTitle, helpTxt, helpLink) {
    function handleClick() {
        // console.log(`onClick = ${helpLink}`)
        if (helpLink !== ``) window.open(encodeURI(helpLink))
        //window.location.href = encodeURI(helpLink)
    }

    const cursorType = helpLink !== `` ? 'pointer' : 'default'
    const helpTxtArOf2 = helpTxt.split('&mylinebrk')
    const helpTxtBlock = (
        <>
            <Typography sx={{ mt: 0.75 }} variant="subtitle2">
                {helpTxtArOf2[0]}
            </Typography>
            <Typography sx={{ mt: 0.75 }} variant="subtitle2">
                {helpTxtArOf2[1]}
            </Typography>
        </>
    )

    const sxPropDiagonal = helpTitle.includes('Bracing')
        ? { mt: { xs: -0.35, sm: 0 }, ml: { xs: 0, sm: 0 } }
        : {}

    const linkElement =
        helpLink !== `` ? (
            <>
                <Typography
                    sx={{ mt: 0.75 }}
                    variant="subtitle2"
                    color={Colors.companyColors.eb_bolt}
                >
                    Click `?` for relevant installation manual entry
                </Typography>
            </>
        ) : null
    return (
        <HtmlTooltip
            placement="bottom-end"
            title={
                <React.Fragment>
                    <Typography color="inherit">{helpTitle}</Typography>
                    {helpTxtBlock}
                    {linkElement}
                    {/* <b>{'some'}</b>
                    <u>{'amazing content'}</u>. */}
                </React.Fragment>
            }
            enterTouchDelay={0} // Open immediately on tap (no 700ms delay)
            leaveTouchDelay={3500} // Stay open 2 seconds after tap (adjust as needed)
            disableHoverListener={false} // optional, but safe to keep
            slotProps={{
                popper: {
                    modifiers: [
                        {
                            name: 'offset',
                            options: {
                                offset: [0, -10],
                            },
                        },
                    ],
                },
            }}
        >
            <IconButton
                onClick={handleClick}
                sx={{
                    cursor: cursorType, // ← this works perfectly

                    // Optional: add nice hover effect that works on desktop
                    '&:hover': {
                        // bgcolor: 'action.hover', // or 'rgba(0,0,0,0.04)'
                        transform: 'scale(1.1)',
                        transition: 'all 0.2s ease',
                    },

                    // Optional: better touch feedback on mobile
                    '&:active': {
                        // bgcolor: 'action.selected',
                        transform: 'scale(0.95)',
                    },

                    // borderRadius: '50%', // keeps it circular
                    // p: 0.5, // reduces padding → smaller hit area
                    minWidth: 36, // smaller than default 48
                    minHeight: 36,
                    width: { xs: 36, sm: 40 }, // exact size you want  ← responsive!
                    height: { xs: 36, sm: 40 },
                }}
            >
                <HelpIcon
                    sx={{
                        // mt: { xs: 6, sm: 3 },
                        ml: { xs: 1.5, sm: 0 },

                        ...sxPropDiagonal,
                        fontSize: 30,
                    }}
                    color="secondary"
                />
            </IconButton>
        </HtmlTooltip>
    )
}

function BomSelect({
    id,
    name,
    labelRow,
    paramKey,
    helpTitle,
    helpTxt,
    helpLink,
    // defaultValue,
    handleInputChange,
    handleValue,
    label,
    // requiredFlag,  // looks cluttered everything is required -- validation occurs on nav.
    // sxProp,
    autoFocusFlag,
    displayValueArray,
    selectInputArray,
    controlSessionObj,
}) {
    const theme = useTheme()
    const isDesktopDisplay = useMediaQuery(theme.breakpoints.up('md'))
    // we have data only here that needs to get into function displayValueArray.
    // so don't have the function result delivered here in the param above but the function address so we call from here.
    let [arDisplay, arInput] =
        id !== 'spacing'
            ? [displayValueArray(), selectInputArray()]
            : [
                  displayValueArray(controlSessionObj.unitValue),
                  selectInputArray(controlSessionObj.unitValue),
              ]
    const sxLRProp = {
        flex: '1',
        justifyContent: { xs: 'center', sm: 'flex-end' },
        alignItems: 'center',

        mb: { xs: 1.5, sm: 0 },
    }
    const sxLabProp = { mt: 0, mb: { xs: 0.5, sm: 0 } }
    const sxUIProp = {
        flex: '1',
        justifyContent: { xs: 'center', sm: 'flex-start' },
        alignItems: 'center',
    }
    const tltip = helpTitle
        ? getToolTip(helpTitle, helpTxt, helpLink) // just until there is no html for the mobile
        : null
    return (
        // TODO: 05/06/23 include aria values for the blo controls complete w prop values
        <>
            <Stack direction="row" sx={sxLRProp}>
                <LabelRow sxProp={sxLabProp}>{labelRow}</LabelRow>
            </Stack>
            <Stack direction="row" sx={sxUIProp}>
                <UIElement
                    sxProp={{ p: { xs: 0, sm: 2 }, py: { xs: 2, sm: 1.1 } }}
                >
                    <InputLabel htmlFor={id} id={`label-${id}`}>
                        {label}
                    </InputLabel>

                    <Select
                        // aria-labelledby="demo-radio-buttons-group-label"
                        id={`select-id-${id}`}
                        name={`select-name-${name}`}
                        label={label}
                        onChange={(e) => handleInputChange(e, { paramKey })}
                        value={handleValue(paramKey, '')}
                        // required={requiredFlag}
                        autoFocus={autoFocusFlag}
                        inputProps={{ id: id }}
                    >
                        {Array(arDisplay.length)
                            .fill(null)
                            .map((_, index) => {
                                const input = arInput[index]
                                const display = arDisplay[index]
                                return (
                                    <MenuItem key={input} value={input}>
                                        {display}
                                    </MenuItem>
                                )
                            })}
                    </Select>
                </UIElement>
                {tltip}
            </Stack>
        </>
    )
}

// onChange={(e) => handleInputChange(e, { paramKey: 'color' })}
// value={searchParams.get('color') || 'white'}

function BomRadioGroup({
    id,
    name,
    labelRow,
    paramKey,
    // defaultValue,
    handleInputChange,
    handleValue,
    helpTitle,
    helpTxt,
    helpLink,
    // label,
    // requiredFlag,  // looks cluttered everything is required -- validation occurs on nav.
    // sxProp,
    // autoFocusFlag,
    displayValueArray,
    selectInputArray,
    controlSessionObj,
}) {
    const theme = useTheme()
    const isDesktopDisplay = useMediaQuery(theme.breakpoints.up('md'))

    let disableBracing = appUtilities.determineBraceDisabling(
        paramKey,
        controlSessionObj
    )
    const sxLRProp = {
        flex: '1',
        justifyContent: { xs: 'center', sm: 'flex-end' },
        alignItems: 'center',
        // justifyContent: 'space-around',
    }
    const sxLabProp = { mt: 0, mb: { xs: 2, sm: 0 } }
    const sxUIProp = {
        flex: '1',
        justifyContent: { xs: 'center', sm: 'flex-start' },
        alignItems: 'center',
    }

    const tltip = helpTitle
        ? getToolTip(helpTitle, helpTxt, helpLink) // just until there is no html for the mobile
        : null
    return (
        <>
            <Stack direction="row" sx={sxLRProp}>
                <LabelRow sxProp={sxLabProp}>{labelRow}</LabelRow>
            </Stack>
            <Stack direction="row" sx={sxUIProp}>
                <UIElement
                    className={'radio'}
                    sxProp={{ p: { xs: 0, sm: 2 }, pr: { sm: 0 } }}
                >
                    <RadioGroup
                        row
                        // aria-labelledby="demo-radio-buttons-group-label"
                        id={id}
                        name={name}
                        onChange={(e) => handleInputChange(e, { paramKey })}
                        value={handleValue(paramKey, '')}
                        sx={{ justifyContent: 'space-evenly' }}

                        // required={requiredFlag}
                    >
                        <FormControlLabel
                            value={selectInputArray[0]}
                            control={<Radio />}
                            label={displayValueArray[0]}
                            disabled={disableBracing}
                        />
                        <FormControlLabel
                            value={selectInputArray[1]}
                            control={<Radio />}
                            label={displayValueArray[1]}
                            disabled={disableBracing}
                        />
                        {displayValueArray.length === 3 && (
                            <FormControlLabel
                                value={selectInputArray[2]}
                                control={<Radio />}
                                label={displayValueArray[2]}
                                disabled={disableBracing}
                            />
                        )}
                    </RadioGroup>
                </UIElement>
                {tltip}
            </Stack>
        </>
    )
}
function BomTextField({
    id,
    name,
    labelRow,
    paramKey,
    // defaultValue,
    handleInputChange,
    handleValue,
    label,
    // requiredFlag,
    sxProp,
    autoFocusFlag,
    controlSessionObj,
}) {
    let err = false

    let unitValue = ''
    let helpMsg = ''
    if (id === 'fence-size') {
        unitValue = controlSessionObj.unitValue
        err = !controlSessionObj.validFence
        if (err) {
            const maxTxt =
                unitValue === 'meters' ? '75,000 meters' : '240,000 feet'
            helpMsg = `Invalid entry. Please enter a number below ${maxTxt}`
        }
    }

    const sxLRProp = {
        flex: '1',
        justifyContent: { xs: 'center', sm: 'flex-end' },
        alignItems: 'center',
    }
    const sxLabProp = { mt: 0, mb: { xs: 2, sm: 0 }, py: { xs: 1, sm: 1.5 } }
    const sxUIProp = {
        flex: '1',
        justifyContent: { xs: 'center', sm: 'flex-start' },
    }

    return (
        <>
            <Stack direction="row" sx={sxLRProp}>
                <LabelRow sxProp={sxLabProp}>{labelRow}</LabelRow>
            </Stack>
            <Stack direction="row" sx={sxUIProp}>
                <UIElement sxProp={{ ...sxProp }}>
                    <TextField
                        id={id}
                        name={name}
                        label={label}
                        onChange={(e) => handleInputChange(e, { paramKey })}
                        value={handleValue(paramKey, '')}
                        // required={requiredFlag}
                        autoFocus={autoFocusFlag}
                        //     shrink: true,
                        // }}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    {unitValue}
                                </InputAdornment>
                            ),
                        }}
                        error={err}
                        helperText={helpMsg}
                    />
                </UIElement>
            </Stack>
        </>
    )
}
// function BomMapCanvas() {
//     return (
//         <>
//             {/* <Grid2 container> */}
//             <Grid2
//                 xs={1}
//                 sx={{
//                     display: 'flex',
//                     justifyContent: 'flex-start',
//                 }}
//             ></Grid2>
//             <Grid2 xs={10}>
//                 <Container>help</Container>
//             </Grid2>
//             <Grid2
//                 xs={1}
//                 sx={{
//                     display: 'flex',
//                     justifyContent: 'flex-end',
//                 }}
//             ></Grid2>
//             {/* </Grid2> */}
//         </>
//     )
// }

export { BomTextField, BomRadioGroup, BomSelect }
